import { Button, IconExport } from '@gmg/gmg-react-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import SupportGraphic from '../../assets/svg/graphic_support-feedback-120.svg';
import SupportIcon from '../../assets/svg/icon_support-24.svg';
import styled from 'styled-components';
import InfoCard from '../shared/InfoCard';

const SupportFeedbackCard = () => {
    const { language } = useContext(AppContext);
    const { t } = useTranslation();
    const requestsUrl = `https://customercare.gmgcolor.com/hc/${language === 'de' ? 'de-de' : 'en-us'}/requests`;

    return (
        <InfoCard
            icon={<SupportIcon />}
            title={t('SupportFeedbackCard.title', 'Support & Feedback')}
            cta={
                <RequestsLink href={requestsUrl} target="_blank" rel="noopener noreferrer" className="px12_600_normal">
                    {t('SupportFeedbackCard.viewRequests', 'View your requests')}
                </RequestsLink>
            }
        >
            <Content>
                <SupportGraphic width={120} height={120} aria-hidden="true" />
                <Copy>
                    <p className="px12_600_normal">
                        {t('SupportFeedbackCard.heading', 'Report a problem or share an idea')}
                    </p>
                    <p className="px12_400_normal">
                        {t('SupportFeedbackCard.description', "Send it our way and we'll route it to the right team.")}
                    </p>
                </Copy>
                <Button
                    variant="primary"
                    icon={<IconExport aria-hidden="true" />}
                    onClick={() => window.open(`${requestsUrl}/new`, '_blank', 'noopener,noreferrer')}
                >
                    {t('SupportFeedbackCard.submitRequest', 'Submit a request')}
                </Button>
            </Content>
        </InfoCard>
    );
};

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    gap: 24px;
    text-align: center;
`;

const Copy = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const RequestsLink = styled.a`
    color: ${props => props.theme.colors.highlight};
`;

export default SupportFeedbackCard;
